import { useRecoilValue } from "recoil";
import { IsInPortrait } from "../../state/selectors";
import { TopBarControl } from "../StyledControl";

function FallBack() {
  const isInPortrait = useRecoilValue(IsInPortrait);

  return (
    <TopBarControl $isInPortrait={isInPortrait}>
      ...
    </TopBarControl>
  );
}

export default FallBack;
